<template>
  <div class="main-style">
    <div @mousemove="move($event)" @mouseout="out" class="preview-box" ref="previewBox">
      <div class="prew-image-style">
        <img :src="url" style="width: 348px;height: 348px">
      </div>

      <div class="hover-box" ref="hoverBox"></div>
      <img @click="onVideoClick" class="play-img-style" src="../../assets/common/ic_shipinbiaozhi_white@2x.png"
           v-if="videourl">
      <div
        style="position: absolute;right: 0;bottom: 0;background-color: #FF6600D0;padding:4px 10px;color: white;font-size: 16px"
        v-if="generalName">
        {{generalName}}
      </div>
    </div>
    <div class="zoom-box" ref="zoomBox" v-show="zoomVisiable">
      <div class="prew-image1-style" ref="bigImg">
        <img :src="gitPrewPick" alt="" style="width: 939px;height:939px ">
      </div>
    </div>
  </div>
</template>

<script>
function offset (el) {
  let top = el.offsetTop
  let left = el.offsetLeft
  while (el.offsetParent) {
    el = el.offsetParent
    top += el.offsetTop
    left += el.offsetLeft
  }
  return {
    left: left,
    top: top
  }
}

export default {
  name: 'LDPicZoom',
  props: {
    url: {
      type: String,
      default: ''
    },
    bigurl: {
      type: String,
      default: ''
    },
    videourl: {
      type: String,
      default: ''
    },
    generalName: {
      type: String,
      default: ''
    }
  },
  computed: {
    gitPrewPick () {
      if (this.bigurl) {
        return this.bigurl
      }
      if (this.url) {
        return this.url
      }
      return ''
    }
  },
  data () {
    return {
      zoomVisiable: false,
      hoverVisiable: false
    }
  },
  methods: {
    onVideoClick () {
      this.$emit('videoclick', this.videourl)
    },
    out () {
      this.zoomVisiable = false
    },
    move (ev) {
      this.init()
      // 鼠标距离屏幕距离
      let moveX = ev.clientX
      let moveY = ev.clientY
      // 大盒子距离顶部的距离
      let offsetLeft = offset(this.oPreviewBox).left

      let offsetTop = offset(this.oPreviewBox).top
      let left = moveX - offsetLeft - this.houverWidth / 2
      let top
      if (this.scroll > 0) {
        top = moveY - offsetTop + this.scroll - this.houverHeight / 2
      } else {
        top = moveY - offsetTop - this.houverHeight / 2
      }
      let maxWidth = this.pWidth - this.houverWidth
      let maxHeight = this.pWidth * 4 / 4 - this.houverHeight
      left = left < 0 ? 0 : left > maxWidth ? maxWidth : left
      top = top < 0 ? 0 : top > maxHeight ? maxHeight : top
      let percentX = left / (maxWidth)
      let percentY = top / (maxHeight)
      this.oHoverBox.style.left = left + 'px'
      this.oHoverBox.style.top = top + 'px'
      this.oBigImg.style.left = percentX * (this.bWidth - this.imgWidth) + 'px'
      this.oBigImg.style.top = percentY * (this.bHeight - this.imgHeight) + 'px'
      this.$emit('move', ev)
      this.zoomVisiable = true
    },
    init () {
      this.oHoverBox = this.$refs.hoverBox
      this.oPreviewBox = this.$refs.previewBox
      this.oBigImg = this.$refs.bigImg
      this.imgBox = this.$refs.zoomBox
      this.houverWidth = this.oHoverBox.offsetWidth
      this.houverHeight = this.oHoverBox.offsetHeight
      this.pWidth = this.oPreviewBox.offsetWidth
      this.pHeight = this.oPreviewBox.offsetHeight
      this.imgWidth = this.oBigImg.offsetWidth
      this.imgHeight = this.oBigImg.offsetHeight
      this.bWidth = this.imgBox.offsetWidth
      this.bHeight = this.imgBox.offsetHeight
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-style {
    position: relative;

    .preview-box {
      width: 348px;
      height: 348px;
      position: relative;

      .prew-image-style {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 348px;
        height: 348px;
        overflow: hidden;
      }

      &:hover .hover-box {
        display: block;
      }

      .hover-box {
        position: absolute;
        display: none;
        left: 0;
        top: 0;
        width: 200px;
        height: 200px;
        border: 1px solid #545454;
        background: url('https://img-tmdetail.alicdn.com/tps/i4/T12pdtXaldXXXXXXXX-2-2.png') repeat 0 0;
        cursor: move;
        user-select: none;
      }
    }

    .zoom-box {
      width: 540px;
      height: 540px;
      background-color: white;
      overflow: hidden;
      position: absolute;
      left: 348px;
      border: 1px solid rgba(186, 186, 186, 1);
      top: -1px;
      z-index: 999999;

      .prew-image1-style {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        overflow: hidden;
        top: 0;
        left: 0;
        width: 939px;
        height: 939px;
      }
    }
  }

  .play-img-style {
    width: 50px;
    height: 50px;
    position: absolute;
    bottom: 5%;
    left: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/LDPicZoom.vue